/** English vocabulary by topic (meanings live in each locale), plus role-play scenarios. */
export type VocabCat = 'school' | 'library' | 'food' | 'shopping' | 'sports' | 'health' | 'home' | 'feelings' | 'safety' | 'nature';

export interface Word {
  w: string;
  cat: VocabCat;
  ex: string;
}

export const WORDS: readonly Word[] = [
  { w: 'classroom', cat: 'school', ex: 'Our classroom has big windows.' },
  { w: 'homework', cat: 'school', ex: 'I finish my homework before dinner.' },
  { w: 'teacher', cat: 'school', ex: 'Our teacher is very kind.' },
  { w: 'pencil', cat: 'school', ex: 'Can I borrow a pencil?' },
  { w: 'eraser', cat: 'school', ex: 'My eraser is shaped like a cat.' },
  { w: 'schedule', cat: 'school', ex: 'What is on the schedule today?' },
  { w: 'borrow', cat: 'library', ex: 'I want to borrow this book.' },
  { w: 'return', cat: 'library', ex: 'Please return it next week.' },
  { w: 'quiet', cat: 'library', ex: 'Please be quiet in the library.' },
  { w: 'novel', cat: 'library', ex: 'This novel is about a brave girl.' },
  { w: 'dictionary', cat: 'library', ex: 'Look it up in the dictionary.' },
  { w: 'shelf', cat: 'library', ex: 'The comics are on the top shelf.' },
  { w: 'menu', cat: 'food', ex: 'Can I see the menu, please?' },
  { w: 'order', cat: 'food', ex: 'Are you ready to order?' },
  { w: 'delicious', cat: 'food', ex: 'This soup is delicious!' },
  { w: 'thirsty', cat: 'food', ex: 'I am thirsty. Can I have some water?' },
  { w: 'bill', cat: 'food', ex: 'Could we have the bill, please?' },
  { w: 'breakfast', cat: 'food', ex: 'I eat eggs for breakfast.' },
  { w: 'price', cat: 'shopping', ex: 'What is the price of this bag?' },
  { w: 'cheap', cat: 'shopping', ex: 'These socks are cheap.' },
  { w: 'expensive', cat: 'shopping', ex: 'That watch is too expensive.' },
  { w: 'receipt', cat: 'shopping', ex: 'Here is your receipt.' },
  { w: 'discount', cat: 'shopping', ex: 'Students get a ten percent discount.' },
  { w: 'cashier', cat: 'shopping', ex: 'Please pay at the cashier.' },
  { w: 'team', cat: 'sports', ex: 'Our team won the game!' },
  { w: 'practice', cat: 'sports', ex: 'We have practice after school.' },
  { w: 'score', cat: 'sports', ex: 'What is the score?' },
  { w: 'swim', cat: 'sports', ex: 'I can swim fifty meters.' },
  { w: 'racket', cat: 'sports', ex: 'Hold the racket with both hands.' },
  { w: 'referee', cat: 'sports', ex: 'The referee blew the whistle.' },
  { w: 'fever', cat: 'health', ex: 'I think I have a fever.' },
  { w: 'headache', cat: 'health', ex: 'I have a headache.' },
  { w: 'medicine', cat: 'health', ex: 'Take this medicine after lunch.' },
  { w: 'rest', cat: 'health', ex: 'You should rest today.' },
  { w: 'nurse', cat: 'health', ex: 'The school nurse is very gentle.' },
  { w: 'bandage', cat: 'health', ex: 'Put a bandage on the cut.' },
  { w: 'kitchen', cat: 'home', ex: 'Mom is cooking in the kitchen.' },
  { w: 'laundry', cat: 'home', ex: 'I help fold the laundry.' },
  { w: 'chores', cat: 'home', ex: 'I do my chores every day.' },
  { w: 'neighbor', cat: 'home', ex: 'Our neighbor has a big dog.' },
  { w: 'family', cat: 'home', ex: 'I love my family.' },
  { w: 'dinner', cat: 'home', ex: 'We eat dinner at seven.' },
  { w: 'nervous', cat: 'feelings', ex: 'I feel nervous before tests.' },
  { w: 'proud', cat: 'feelings', ex: 'I am proud of you!' },
  { w: 'grateful', cat: 'feelings', ex: 'I am grateful for my friends.' },
  { w: 'lonely', cat: 'feelings', ex: 'He felt lonely at the new school.' },
  { w: 'excited', cat: 'feelings', ex: 'We are excited about the trip!' },
  { w: 'calm', cat: 'feelings', ex: 'Take a deep breath and stay calm.' },
  { w: 'password', cat: 'safety', ex: 'Never share your password.' },
  { w: 'privacy', cat: 'safety', ex: 'Protect your privacy online.' },
  { w: 'stranger', cat: 'safety', ex: 'Don’t send photos to a stranger.' },
  { w: 'report', cat: 'safety', ex: 'Report the message and tell an adult.' },
  { w: 'block', cat: 'safety', ex: 'You can block people who scare you.' },
  { w: 'scam', cat: 'safety', ex: 'Free money online is usually a scam.' },
  { w: 'blossom', cat: 'nature', ex: 'The cherry blossoms are pink.' },
  { w: 'pond', cat: 'nature', ex: 'Fish swim in the pond.' },
  { w: 'breeze', cat: 'nature', ex: 'A cool breeze blows through the park.' },
  { w: 'butterfly', cat: 'nature', ex: 'A butterfly landed on the flower.' },
  { w: 'sunset', cat: 'nature', ex: 'The sunset is orange and pink.' },
  { w: 'puddle', cat: 'nature', ex: 'Don’t jump in the puddle!' },
  { w: 'responsibility', cat: 'school', ex: 'I take responsibility for my decisions.' },
  { w: 'discipline', cat: 'school', ex: 'Self-discipline leads to freedom.' },
  { w: 'procrastinate', cat: 'school', ex: 'Don’t procrastinate on your homework.' },
  { w: 'empathize', cat: 'feelings', ex: 'We should empathize with people who are struggling.' },
  { w: 'resilient', cat: 'feelings', ex: 'She stayed resilient despite every difficulty.' },
  { w: 'boundary', cat: 'feelings', ex: 'It is healthy to set clear personal boundaries.' },
  { w: 'cyberbullying', cat: 'safety', ex: 'Never take part in cyberbullying.' },
];

export const CATS: readonly VocabCat[] = ['school', 'library', 'food', 'shopping', 'sports', 'health', 'home', 'feelings', 'safety', 'nature'];

export interface Turn {
  npc: string;
  options: { t: string; ok: boolean }[];
}

export type ScenarioId =
  | 'cafe' | 'library' | 'store' | 'nurse' | 'directions' | 'newFriend' | 'restaurant' | 'sports' | 'gift' | 'phone'
  | 'swim' | 'tennis' | 'horse' | 'clothes' | 'music' | 'art';

/** English role-plays: the lines stay in English on purpose — that's the practice. */
export const SCENARIOS = {
  cafe: {
    icon: '☕',
    turns: [
      { npc: 'Hi! Welcome to Little Lantern Café. What would you like?', options: [{ t: 'Can I have a hot cocoa, please?', ok: true }, { t: 'Cocoa. Now.', ok: false }, { t: 'I like blue.', ok: false }] },
      { npc: 'Sure! Small or large?', options: [{ t: 'Small, please.', ok: true }, { t: 'Yes.', ok: false }, { t: 'Goodbye!', ok: false }] },
      { npc: 'That’s forty dollars.', options: [{ t: 'Here you are. Thank you!', ok: true }, { t: 'Too much, I won’t pay.', ok: false }, { t: 'I am forty.', ok: false }] },
    ],
  },
  library: {
    icon: '📚',
    turns: [
      { npc: 'Hello. How can I help you?', options: [{ t: 'I’d like to borrow this book, please.', ok: true }, { t: 'Give me book.', ok: false }, { t: 'I’m hungry.', ok: false }] },
      { npc: 'May I see your student card?', options: [{ t: 'Of course, here it is.', ok: true }, { t: 'No way!', ok: false }, { t: 'It’s raining.', ok: false }] },
      { npc: 'Please return it in two weeks.', options: [{ t: 'Okay, I will. Thanks!', ok: true }, { t: 'Maybe never.', ok: false }, { t: 'Two weeks is a color.', ok: false }] },
    ],
  },
  store: {
    icon: '🏪',
    turns: [
      { npc: 'Hi there! Can I help you find something?', options: [{ t: 'Yes, where are the rice balls?', ok: true }, { t: 'Leave me alone.', ok: false }, { t: 'I am a rice ball.', ok: false }] },
      { npc: 'They’re next to the drinks. Anything else?', options: [{ t: 'No, that’s all. Thank you!', ok: true }, { t: 'Drinks are boring.', ok: false }, { t: 'Next to me?', ok: false }] },
      { npc: 'Would you like a bag?', options: [{ t: 'No, thanks. I have my own bag.', ok: true }, { t: 'Bag bag bag.', ok: false }, { t: 'I want ten bags for free.', ok: false }] },
    ],
  },
  nurse: {
    icon: '🩺',
    turns: [
      { npc: 'Hello, dear. What’s wrong?', options: [{ t: 'I have a headache and I feel tired.', ok: true }, { t: 'Nothing, I want to skip class.', ok: false }, { t: 'I like headaches.', ok: false }] },
      { npc: 'Do you have a fever?', options: [{ t: 'I don’t think so, but I feel hot.', ok: true }, { t: 'Fever is my friend.', ok: false }, { t: 'What is your name?', ok: false }] },
      { npc: 'Rest here for a while and drink some water.', options: [{ t: 'Thank you, I will.', ok: true }, { t: 'Water is gross.', ok: false }, { t: 'I want to run now.', ok: false }] },
    ],
  },
  directions: {
    icon: '🗺️',
    turns: [
      { npc: 'Excuse me, can I help you? You look lost.', options: [{ t: 'Yes, how do I get to the park?', ok: true }, { t: 'I am not lost, I am a tree.', ok: false }, { t: 'Go away.', ok: false }] },
      { npc: 'Go straight and turn left at the crosswalk.', options: [{ t: 'Straight, then left. Got it!', ok: true }, { t: 'Left is wrong.', ok: false }, { t: 'I can’t walk.', ok: false }] },
      { npc: 'It’s about five minutes away. Have a nice day!', options: [{ t: 'Thank you so much! You too.', ok: true }, { t: 'Five minutes is too long.', ok: false }, { t: 'Nice day is a fish.', ok: false }] },
    ],
  },
  newFriend: {
    icon: '👋',
    turns: [
      { npc: 'Hi! I’m new here. My name is Lily.', options: [{ t: 'Nice to meet you, Lily! I’m glad you’re here.', ok: true }, { t: 'So what?', ok: false }, { t: 'I am new too, I am a phone.', ok: false }] },
      { npc: 'What do you like to do after school?', options: [{ t: 'I like reading and playing basketball.', ok: true }, { t: 'None of your business.', ok: false }, { t: 'After school is Tuesday.', ok: false }] },
      { npc: 'Can I sit with you at lunch?', options: [{ t: 'Of course! Let’s go together.', ok: true }, { t: 'No, sit alone.', ok: false }, { t: 'Lunch is a sandwich.', ok: false }] },
    ],
  },
  restaurant: {
    icon: '🍜',
    turns: [
      { npc: 'Good evening! Table for how many?', options: [{ t: 'For four people, please.', ok: true }, { t: 'Table is wood.', ok: false }, { t: 'I want the kitchen.', ok: false }] },
      { npc: 'Are you ready to order?', options: [{ t: 'Yes, I’d like the beef noodles, please.', ok: true }, { t: 'Noodles! Fast!', ok: false }, { t: 'I am ready to sleep.', ok: false }] },
      { npc: 'How is everything?', options: [{ t: 'It’s delicious, thank you!', ok: true }, { t: 'Everything is a word.', ok: false }, { t: 'Bring more, I won’t pay.', ok: false }] },
    ],
  },
  sports: {
    icon: '🏐',
    turns: [
      { npc: 'Hey! Do you want to join our volleyball practice?', options: [{ t: 'Yes, I’d love to! What should I do?', ok: true }, { t: 'Volleyball is for babies.', ok: false }, { t: 'I want pizza.', ok: false }] },
      { npc: 'Stand here and pass the ball to me.', options: [{ t: 'Okay! Here it comes!', ok: true }, { t: 'You pass it, I’m lazy.', ok: false }, { t: 'The ball is round.', ok: false }] },
      { npc: 'Great job! Same time next week?', options: [{ t: 'Sure! See you next week.', ok: true }, { t: 'Never again.', ok: false }, { t: 'Next week is a fruit.', ok: false }] },
    ],
  },
  gift: {
    icon: '🎁',
    turns: [
      { npc: 'Welcome to the gift shop! Who are you shopping for?', options: [{ t: 'It’s my mom’s birthday. Do you have any ideas?', ok: true }, { t: 'For nobody.', ok: false }, { t: 'I am a gift.', ok: false }] },
      { npc: 'How about this scarf or these flowers?', options: [{ t: 'The flowers are lovely. How much are they?', ok: true }, { t: 'Both are ugly.', ok: false }, { t: 'Flowers can fly.', ok: false }] },
      { npc: 'They’re two hundred dollars. Shall I wrap them?', options: [{ t: 'Yes, please. Thank you!', ok: true }, { t: 'Wrap yourself.', ok: false }, { t: 'Two hundred is my age.', ok: false }] },
    ],
  },
  phone: {
    icon: '📞',
    turns: [
      { npc: 'Hello? Is this the Lin family?', options: [{ t: 'Yes, this is the Lin family. Who’s calling, please?', ok: true }, { t: 'Who cares?', ok: false }, { t: 'I am a family.', ok: false }] },
      { npc: 'This is Mr. Chen from the library. Is your mom home?', options: [{ t: 'One moment, please. I’ll get her.', ok: true }, { t: 'No. Bye.', ok: false }, { t: 'Moms are home.', ok: false }] },
      { npc: 'Thank you, that’s very polite!', options: [{ t: 'You’re welcome. Have a nice day!', ok: true }, { t: 'I know.', ok: false }, { t: 'Polite is a color.', ok: false }] },
    ],
  },
} as Record<ScenarioId, { icon: string; turns: Turn[] }>;

Object.assign(SCENARIOS, {
  swim: {
    icon: '🏊',
    turns: [
      { npc: 'Hi! Is this your first time at the pool?', options: [{ t: 'Yes, it is. What are the rules?', ok: true }, { t: 'Pools are boring.', ok: false }, { t: 'I am a fish.', ok: false }] },
      { npc: 'Please take a shower first and don’t run.', options: [{ t: 'Okay, I’ll walk slowly.', ok: true }, { t: 'I like running!', ok: false }, { t: 'Shower is a bird.', ok: false }] },
      { npc: 'Great! The shallow end is on the left.', options: [{ t: 'Thanks! I’ll start there.', ok: true }, { t: 'I want the deep end alone.', ok: false }, { t: 'Left is my favourite color.', ok: false }] },
    ],
  },
  tennis: {
    icon: '🎾',
    turns: [
      { npc: 'Do you want to play a game of tennis?', options: [{ t: 'Sure! Can you teach me how to serve?', ok: true }, { t: 'Tennis is stupid.', ok: false }, { t: 'I am a racket.', ok: false }] },
      { npc: 'Throw the ball up and hit it at the top.', options: [{ t: 'Like this? Oops, let me try again!', ok: true }, { t: 'No, you do it.', ok: false }, { t: 'The ball is sleeping.', ok: false }] },
      { npc: 'Nice serve! The score is fifteen–love.', options: [{ t: 'Yes! Let’s keep playing.', ok: true }, { t: 'Love is gross.', ok: false }, { t: 'Fifteen is my age.', ok: false }] },
    ],
  },
  horse: {
    icon: '🐴',
    turns: [
      { npc: 'Welcome to the stables! Have you ridden a horse before?', options: [{ t: 'No, never. Is it safe?', ok: true }, { t: 'Horses are cars.', ok: false }, { t: 'Give me the fastest one now!', ok: false }] },
      { npc: 'It’s safe if you wear a helmet and listen to me.', options: [{ t: 'Okay, I’m wearing my helmet.', ok: true }, { t: 'Helmets are ugly.', ok: false }, { t: 'I listen to music.', ok: false }] },
      { npc: 'Hold the reins gently and sit up straight.', options: [{ t: 'Like this? This is fun!', ok: true }, { t: 'Pull hard!', ok: false }, { t: 'I am straight.', ok: false }] },
    ],
  },
  clothes: {
    icon: '👕',
    turns: [
      { npc: 'Hello! Can I help you find something?', options: [{ t: 'Yes, I’m looking for a hoodie.', ok: true }, { t: 'No. Go away.', ok: false }, { t: 'I want a fish.', ok: false }] },
      { npc: 'What size do you wear?', options: [{ t: 'Small, I think. Can I try it on?', ok: true }, { t: 'Size dog.', ok: false }, { t: 'I don’t wear clothes.', ok: false }] },
      { npc: 'The fitting room is over there.', options: [{ t: 'Thank you! It fits perfectly.', ok: true }, { t: 'Rooms are fitting.', ok: false }, { t: 'I’ll take it without paying.', ok: false }] },
    ],
  },
  music: {
    icon: '🎵',
    turns: [
      { npc: 'Welcome to music class! Which instrument do you like?', options: [{ t: 'I like the piano. It sounds beautiful.', ok: true }, { t: 'Music is noise.', ok: false }, { t: 'I like sandwiches.', ok: false }] },
      { npc: 'Can you clap this rhythm with me? One, two, three!', options: [{ t: 'Clap, clap, clap! Like this?', ok: true }, { t: 'No clapping.', ok: false }, { t: 'Three is a tree.', ok: false }] },
      { npc: 'Wonderful! Let’s practice together next week.', options: [{ t: 'I can’t wait! Thank you.', ok: true }, { t: 'Never again.', ok: false }, { t: 'Next week is music.', ok: false }] },
    ],
  },
  art: {
    icon: '🎨',
    turns: [
      { npc: 'Today we are painting a landscape. What will you paint?', options: [{ t: 'A park with cherry trees and a pond.', ok: true }, { t: 'Nothing. Art is boring.', ok: false }, { t: 'I paint my dog blue.', ok: false }] },
      { npc: 'What colours do you need?', options: [{ t: 'Pink, green and light blue, please.', ok: true }, { t: 'All of them, now!', ok: false }, { t: 'Colours are loud.', ok: false }] },
      { npc: 'Beautiful! Can I hang it on the wall?', options: [{ t: 'Of course! I’m proud of it.', ok: true }, { t: 'No, it’s mine forever.', ok: false }, { t: 'Walls are hungry.', ok: false }] },
    ],
  },
});

/** Which scenario fits where you are standing. */
export const SCENARIO_BY_AREA: Record<string, ScenarioId> = {
  cafeteria: 'restaurant',
  library: 'library',
  store: 'store',
  park: 'directions',
  street: 'directions',
  classroom: 'newFriend',
  field: 'sports',
  home: 'phone',
  counsel: 'nurse',
  restroom: 'nurse',
  yard: 'newFriend',
  neighborhood: 'gift',
  cafe: 'cafe',
  giftShop: 'gift',
  nurse: 'nurse',
  gym: 'sports',
  pool: 'sports',
  restaurant: 'restaurant',
  mall: 'gift',
  music: 'music',
  artRoom: 'art',
  dept: 'clothes',
  stable: 'horse',
  tennis: 'tennis',
  volley: 'sports',
  sportsCenter: 'sports',
  corridor: 'newFriend',
  lobby: 'directions',
  schoolGate: 'directions',
};
